<template>
  <div class="triangle-popup dib">
    <div class="popup-box" :class="boxClass">
      <triangle-ico :type="type" :color="background" :shadow="shadow" :size="icoSize"></triangle-ico>
      <div class="popup-inner" :style="innerStyle">
        <div class="popup-content lh1" v-if="content !== undefined">
          {{content}}
        </div>
        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TrianglePopup",
    props: {
      type: {
        type: String,
        default: 'left',
      },
      content: String,
      shadowColor: String,
      icoPosition: {
        type: String | Number,
        default: 'center',
      },
      background: {
        type: String,
        default: '#ff4436',
      },
      icoSize: {
        type: Number,
        default: 13,
      },
      shadow: {
        type: Boolean | Number | String,
        default: false,
      },
      color: {
        type: String,
        default: '#fff',
      }
    },
    computed: {
      boxClass() {
        let {type, icoPosition} = this;
        let arr = [type];
        switch (type) {
          case 'left':
          case 'right':
            arr.push('flex');
            break;
          case 'top':
          case 'bottom':
            arr.push('flex-col');
            break;
        }
        icoPosition === 'center' && arr.push('aic');
        return arr;
      },
      innerStyle() {
        let {shadow, shadowColor, background, color} = this;
        let obj = {
          background,
          color,
        };
        switch (typeof shadow) {
          case 'boolean':
            obj.boxShadow = shadow ? `0 0 2px ${shadowColor || background}` : '';
            break;
          case 'string':
          case 'number':
            obj.boxShadow = !isNaN(shadow) ? `0 0 ${shadow}px ${shadowColor || background}` : '';
            break;
        }
        return obj;
      },
    },
  }
</script>

<style scoped lang="less">
  .triangle-popup {
  }

  .popup-box {
    &.right {
      flex-direction: row-reverse;
    }
    &.bottom {
      flex-direction: column-reverse;
    }
  }

  .popup-inner {
    border-radius: 4px;
  }

  .popup-content {
    padding: 6px 8px;
    font-size: 14px;
  }
</style>